// It is to be used in persistence.js and class components.
// For the functional components, we can use a `useHistory` hook from 'react-router`
import { createBrowserHistory } from 'history'
export default createBrowserHistory()
